import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { mapBoundariesSelector } from '~/store/boundaryItems/boundaryItems.selectors';

export const getBoundaryStateItemSelector = createStateSelector([
  mapBoundariesSelector,
], (boundaryItems) => (boundaryId: number, boundaryGroupId: number) =>
  boundaryItems.get(boundaryGroupId)?.get(boundaryId) ?? null);

export const useBoundaryStateItem = () => {
  const getBoundaryStateItem = useSelector(getBoundaryStateItemSelector);

  return {
    getBoundaryStateItem,
  };
};
